import React from 'react'
import { Button } from 'cwp-components/forms/Buttons'
import humanize from 'humanize'
import { useNavigate } from 'react-router-dom'
import { LawTechArticle as Article } from './LawTechSlider'

const DATE_FORMAT = 'jS M, y'

interface LawTechArticleProps {
  article: Article
}
export const LawTechArticle = ({ article }: LawTechArticleProps) => {
  const navigate = useNavigate()

  return (
    <div className='flex flex-col items-center w-[295px] lg:[w-300px] 2xl:w-[380px] 2xl:h-[480px] rounded-lg bg-white shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)] relative border-box'>
      <img
        src={article?.cover_image}
        alt={article?.title}
        className='w-full h-[220px] object-cover rounded-t-[8px] block'
      />
      <div className='flex items-center justify-center gap-[10px] px-[8px] py-[4px] rounded-[12px] bg-white text-sm font-medium text-[#122D5C] text-center 2xl:px-2 2xl:py-1 absolute left-[30px] top-[20px]'>
        <span>
          {humanize.date(DATE_FORMAT, new Date(article?.publish_date))}
        </span>
      </div>
      <div className='absolute flex h-[40px] p-[4px] items-center gap-[4px] rounded-[30px] bg-[#EBFBFF] right-[24px] bottom-[154px] 2xl:right-0 2xl:top-[200px] 2xl:bottom-auto'>
        <img
          className='rounded-full h-[24px] w-[24px]'
          style={{
            background: `url(${article?.author?.avatar}) lightgray 50% / cover no-repeat`,
          }}
        />
        <p className='text-center text-[10px] font-normal leading-3 text-black'>
          {article?.author?.name}
        </p>
      </div>

      <div className='flex flex-col items-center 2xl:items-end gap-4 2xl:gap-6 self-stretch px-5 pt-[30px] pb-4 2xl:pb-6 mt-[30px]'>
        <div className='flex flex-col items-start gap-[6px] self-stretch'>
          <h3 className='text-[#001A3D] text-sm font-medium  2xl:text-lg 2xl:font-bold 2xl:leading-[24px] 2xl:tracking-wide'>
            {article?.title}
          </h3>
          <p className='text-[#6E7785] font-normal tracking-wide text-xs leading-4 2xl:text-base 2xl:leading-5'>
            {article?.summary.substring(0, 150)}
          </p>
        </div>
        <Button
          onClick={() => navigate(`/blogs/${article?.slug}`)}
          className='btn-default mb-6 text-[#1C7D93]'
        >
          View
        </Button>
      </div>
    </div>
  )
}
